<div class="toolbar-container">
  <fd-toolbar [fdType]="'transparent'" [clearBorder]="true">
    <div class="atom-nav-condenser" [ngClass]="condenseWrapperClass()">
      <button
        [title]="condenseButtonTitle()"
        fd-shellbar-side-nav
        fd-button
        [fdType]="'transparent'"
        (click)="onToggleCondensed()"
      >
        <app-icon icon="bars" size="lg"></app-icon>
      </button>
    </div>
    <div class="logo"></div>
    <h5 fd-title style="display: none"></h5>
    <h5 fd-title>Unified Services Workspace</h5>
    <app-go-to-path #goToPathPopover></app-go-to-path>
    <fd-toolbar-spacer></fd-toolbar-spacer>

    @if (Utils.isAiAssistantAvailable()) {
      <button
        fd-button
        [fdCompact]="true"
        [fdType]="'transparent'"
        [attr.aria-pressed]="(aiAssistantService.isOpen$ | async) ? 'true' : 'false'"
        [class.is-active]="aiAssistantService.isOpen$ | async"
        title="Workspace Assistant"
        aria-label="Workspace Assistant"
        id="ai-assistant-btn"
        (click)="onToggleAiAssistant()"
      >
        <fd-icon glyph="ai" class="ai-assistant-glyph"></fd-icon>
      </button>
    }

    <fd-popover
      #helpPopover
      [noArrow]="false"
      [focusTrapped]="true"
      [focusAutoCapture]="true"
      [(isOpen)]="isHelpPopoverOpen"
      [closeOnOutsideClick]="true"
    >
      <fd-popover-control>
        @if (Utils.isAiAssistantAvailable()) {
          <button
            fd-button
            [fdCompact]="true"
            [fdType]="'transparent'"
            title="Help & Support"
            aria-label="Help & Support"
            id="help-btn"
          >
            <fd-icon glyph="sys-help" class="ai-assistant-glyph"></fd-icon>
          </button>
        } @else {
          <button
            fd-button
            [fdCompact]="true"
            [fdType]="'transparent'"
            label="Help & Support"
            id="help-btn"
          >
            <app-icon icon="angle-down"></app-icon>
          </button>
        }
      </fd-popover-control>
      <fd-popover-body class="help-menu-side">
        <fd-side-nav>
          @if (isHelpPopoverOpen) {
            <div fd-side-nav-main>
              <ul class="help-menu" fd-nested-list [textOnly]="true">
                @if (!Utils.isPrivateCloud) {
                  <li fd-nested-list-item [expanded]="false">
                    <div fd-nested-list-content>
                      <a
                        fd-nested-list-link
                        fd-nested-list-expand-icon
                        id="documentation-btn"
                      >
                        <app-icon icon="question-circle" size="lg"></app-icon>
                        <span fd-nested-list-title>Documentation</span>
                      </a>
                    </div>
                    <ul fd-nested-list>
                      <li fd-nested-list-item>
                        <a
                          fd-nested-list-link
                          id="atom-workspace-documentation-btn"
                          (click)="onWorkspaceHelpClick()"
                        >
                          <span fd-nested-list-title
                            >Workspace Documentation</span
                          >
                        </a>
                      </li>
                      <li fd-nested-list-item>
                        <a
                          fd-nested-list-link
                          id="atom-documentation-btn"
                          (click)="onHelpClick()"
                        >
                          <span fd-nested-list-title
                            >Unified Services Documentation</span
                          >
                        </a>
                      </li>
                      <li fd-nested-list-item>
                        <a
                          fd-nested-list-link
                          id="cli-documentation-btn"
                          (click)="onCliClick()"
                        >
                          <span fd-nested-list-title>Uctl Documentation</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                }
                <li fd-nested-list-item>
                  <a
                    fd-nested-list-link
                    id="open-support-btn"
                    (click)="openSupportDialog()"
                    [selected]="false"
                  >
                    <app-icon
                      [icon]="[$any('workspace'), $any('support')]"
                      size="lg"
                    ></app-icon>
                    <span fd-nested-list-title>Support</span>
                  </a>
                </li>
                @if (!Utils.isPrivateCloud) {
                  <li fd-nested-list-item>
                    <a
                      fd-nested-list-link
                      target="_blank"
                      href="{{ Const.TEAMS_URL }}"
                    >
                      <div class="teams-icon"></div>
                      <app-icon
                        [icon]="[$any('workspace'), $any('teams')]"
                        size="lg"
                      ></app-icon>
                      <span fd-nested-list-title>Collaboration (Teams)</span>
                    </a>
                  </li>
                }
                <li fd-nested-list-item>
                  <a
                    fd-nested-list-link
                    target="_blank"
                    (click)="onClickDownload()"
                    href="{{ Const.DOWNLOAD_UCTL }}"
                  >
                    <app-icon
                      [icon]="[$any('workspace'), $any('uctl')]"
                      size="lg"
                    ></app-icon>
                    <span fd-nested-list-title>Download Uctl</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </fd-side-nav>
      </fd-popover-body>
    </fd-popover>

    <fd-popover
      #userPopover
      placement="bottom"
      [noArrow]="false"
      [focusTrapped]="true"
      [focusAutoCapture]="true"
      [closeOnOutsideClick]="true"
      [(isOpen)]="isUserPopoverOpen"
    >
      <fd-popover-control>
        <button
          fd-button
          [fdCompact]="true"
          [fdType]="'transparent'"
          label="{{ username }}"
          id="username-btn"
        >
          <app-icon icon="angle-down"></app-icon>
        </button>
      </fd-popover-control>
      <fd-popover-body>
        @if (isUserPopoverOpen) {
          <div class="header-dropdown-wrap">
            <ul fd-list class="user-menu">
              <li fd-list-item class="theme-changer-wrap">
                <fd-segmented-button
                  id="theme-switcher-button"
                  [ngModel]="(theme$ | async)?.selectedTheme"
                  (ngModelChange)="changeTheme($event)"
                >
                  <button
                    class="theme-button"
                    fd-button
                    title="Light Theme"
                    [value]="Theme.ATOM_LIGHT"
                  >
                    <app-icon [icon]="lightIcon()"></app-icon>
                  </button>
                  <button
                    class="theme-button"
                    fd-button
                    title="Dark Theme"
                    [value]="Theme.ATOM_DARK"
                  >
                    <app-icon [icon]="darkIcon()"></app-icon>
                  </button>
                  <button
                    class="theme-button"
                    fd-button
                    title="High Contrast Black Theme"
                    [value]="Theme.ATOM_HCB"
                  >
                    <app-icon [icon]="hcbIcon()"></app-icon>
                  </button>
                </fd-segmented-button>
              </li>
              <li fd-list-item class="button-wrap">
                <button
                  fd-button
                  (click)="openUserInfoDialog()"
                  fdType="transparent"
                  id="user-info-btn"
                  title="User Information"
                >
                  <app-icon
                    [icon]="['far', 'circle-user']"
                    [fixedWidth]="true"
                  ></app-icon>
                  <span
                    i18n="
                      XMIT|About action in the user action
                      sheet@@header.user.about"
                    >User Information</span
                  >
                </button>
              </li>
              <li fd-list-item class="button-wrap">
                <button
                  fd-button
                  (click)="logout()"
                  fdType="transparent"
                  title="Log Out"
                  id="logout-btn"
                  glyphPosition="after"
                >
                  <app-icon icon="power-off" [fixedWidth]="true"></app-icon>
                  <span
                    i18n="
                      XMIT|Log out action in the user action
                      sheet@@header.user.logout"
                    >Log Out</span
                  >
                </button>
              </li>
            </ul>
          </div>
        }
      </fd-popover-body>
    </fd-popover>
  </fd-toolbar>
</div>
